import {FC, useEffect} from 'react';
import {AppBar, CssBaseline, makeStyles, Tab, Tabs, Toolbar, Typography} from '@material-ui/core';
import {Switch, Route, useLocation, useHistory, Redirect} from 'react-router-dom';

import WebDemoPage from './pages/WebDemoPage';
import ProjectPage from './pages/ProjectPage';

const useStyles = makeStyles(theme => ({
  appBar: {
    borderBottom: "1px solid #ddd"
  },
  toolbar: {
    minHeight: 0
  },
  title: {
    flexGrow: 1,
  },
  tab: {
    textTransform: 'none'
  }
}));

const App: FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const routes = [
    {
      path: '/',
      title: 'Project',
      component: ProjectPage
    },
    {
      path: '/demo',
      title: 'Web Demo',
      component: WebDemoPage
    }
  ]

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <CssBaseline />
      <AppBar className={classes.appBar} elevation={0} color="default" position="sticky">
        <Toolbar className={classes.toolbar}>
          <Typography className={classes.title} variant="h6">RVM</Typography>
          <Tabs value={location.pathname} onChange={(e, v) => history.replace(v)}>
            {routes.map(({path, title}) => <Tab className={classes.tab} key={path} label={title} value={path} />)}
          </Tabs>
        </Toolbar>
      </AppBar>
      <Switch>
        {routes.map(({path, component}) => <Route key={path} path={path} component={component} exact/>)}
        <Route>
          <Redirect to="/"/>
        </Route>
      </Switch>
    </>
  );
}

export default App;